import { useState, useEffect } from 'react';
import If from '@components/If';
import loadable from '@loadable/component';
import { AppleNative } from './AppleNative';
const Web = loadable(() => import('./AppleWeb'));

interface Props {
  onSuccess: (
    token: string,
    user?: {
      email: string;
      name: {
        firstName: null | string;
        lastName: null | string;
      };
    }
  ) => void;
  disabled?: boolean;
}
export const AppleSwitcher = (props: Props) => {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    if (IS_NATIVE) {
      async function checkPlatform() {
        const { Device } = await import('@capacitor/device');
        const response = await Device.getInfo();
        if (response.platform === 'ios') {
          /** hide apple sign in if android sorry */
          setEnabled(true);
        }
      }
      checkPlatform();
    }
  }, []);
  return (
    <If conditions={{ native: IS_NATIVE && enabled, web: !IS_NATIVE }}>
      {{
        native: () => <AppleNative {...props} />,
        web: () => <Web {...props} />,
      }}
    </If>
  );
};
